import ExitConfirmModal from '#client/components/CheckDeposit/components/ExitConfirmModal';
import { MODAL_NAMES } from '#client/constants/modals';
import useModalContext from '#client/hooks/useModalContext';

import { MITEK_PERMISSION_ERROR } from './useMitekSdk/constants';

export const useMitekErrorHandler = () => {
  const { openModal } = useModalContext();

  const mitekErrorHandler = (errors, callback) => {
    const errorCode = errors[0]?.code;
    const message = MITEK_PERMISSION_ERROR[errorCode] || MITEK_PERMISSION_ERROR.default;

    if (errorCode) {
      openModal({
        component: ExitConfirmModal,
        name: MODAL_NAMES.CHECK_DEPOSIT_EXIT_CONFIRM_MODAL,
        title: message.title,
        description: message.description,
        cancelText: 'Close',
        callback
      });
    }
  };

  return {
    mitekErrorHandler
  };
};
